<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-8 md:pb-12">
          <h2 class="h2 mb-4">ご利用料金</h2>
        </div>

        <!-- Items -->
        <div
          class="max-w-sm mx-auto grid gap-8 grid-cols-1 lg:gap-16 items-start md:max-w-2xl lg:max-w-none"
          data-aos-id-blocks
        >
          <!-- 1st item -->
          <div class="relative flex flex-col items-center" data-aos="fade-up" data-aos-anchor="[data-aos-id-blocks]">
            <h4 class="h4 mb-2">プログラムの内容により異なります。まずはお問い合わせください。</h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PricePersonal",
}
</script>
